import type { WithCursorsOptions } from '@slate-yjs/core';
import { withCursors } from '@slate-yjs/core';
import type { Awareness } from 'y-protocols/awareness';

import type { CursorEditor, CursorRequiredEditor } from './cursor-editor';
import type { CursorData } from './types';

export type CreateWithCursorOptions = WithCursorsOptions & { awareness: Awareness };

export function createWithCursors({ awareness, ...opts }: CreateWithCursorOptions) {
  return <T extends CursorRequiredEditor>(editor: T) => {
    const e = withCursors<CursorData, T>(editor, awareness, opts) as T & CursorEditor;
    e.__cursorEditor = true;
    return e;
  };
}
